module.exports = __webpack_public_path__ + "img/avatar_man.9438426b.jpg";